import React from 'react';

const STATUS_OPTIONS = [
  { value: '',          label: 'All statuses' },
  { value: 'SCHEDULED', label: 'Scheduled'    },
  { value: 'ACTIVE',    label: 'Active'       },
  { value: 'COMPLETED', label: 'Completed'    },
  { value: 'CANCELLED', label: 'Cancelled'    },
];

const RECOMMENDATION_OPTIONS = [
  { value: '',         label: 'Any recommendation' },
  { value: 'hire',     label: 'Hire / Strong Hire' },
  { value: 'no_hire',  label: 'No Hire'            },
  { value: 'pending',  label: 'Pending scorecard'  },
];

export default function PipelineFilters({ value, onChange, totalCards, filteredCount }) {
  const setField = (field, v) => onChange({ ...value, [field]: v });

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 mb-4">
      <input
        type="text"
        value={value.search}
        onChange={(e) => setField('search', e.target.value)}
        placeholder="Search candidate or interview…"
        className="flex-1 min-w-0 text-sm border border-line rounded-lg
                   px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-teal-500 bg-surface text-ink"
      />

      <select
        value={value.status}
        onChange={(e) => setField('status', e.target.value)}
        className="text-sm border border-line rounded-lg px-3 py-1.5
                   focus:outline-none focus:ring-2 focus:ring-teal-500 bg-surface text-ink"
      >
        {STATUS_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>

      <select
        value={value.recommendation}
        onChange={(e) => setField('recommendation', e.target.value)}
        className="text-sm border border-line rounded-lg px-3 py-1.5
                   focus:outline-none focus:ring-2 focus:ring-teal-500 bg-surface text-ink"
      >
        {RECOMMENDATION_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>

      <span className="text-xs font-mono text-ink-faint whitespace-nowrap">
        {filteredCount} / {totalCards}
      </span>
    </div>
  );
}

/**
 * Apply the filter object to a flat list of cards.
 *  - search:         case-insensitive match on candidateName / candidateEmail / title
 *  - status:         exact ScheduleStatus match
 *  - recommendation: 'hire' / 'no_hire' / 'pending' (pending = null/blank)
 */
export function applyPipelineFilters(cards, filters) {
  const search = (filters.search || '').trim().toLowerCase();
  const status = filters.status || '';
  const rec    = filters.recommendation || '';

  return cards.filter((c) => {
    if (search) {
      const hay = `${c.candidateName || ''} ${c.candidateEmail || ''} ${c.title || ''}`.toLowerCase();
      if (!hay.includes(search)) return false;
    }
    if (status && c.status !== status) return false;
    if (rec) {
      const r = (c.scorecardRecommendation || '').toLowerCase();
      if (rec === 'hire'    && !/strong\s*hire|hire/.test(r))   return false;
      if (rec === 'no_hire' && !/no\s*hire|reject/.test(r))     return false;
      if (rec === 'pending' && r)                                return false;
    }
    return true;
  });
}
